import { Injectable } from '@nestjs/common';
import { jobConfigs } from '../../../config';
import { BULLJSQUEUENAMES, BULLJSQUEUENAMESTOMODULEMAP } from '@gtpl/shared-models/common-models';

@Injectable()
export class BullArenaUIProvider {
  constructor() {

  }

  createArenaQueues() {
    return Object.keys(BULLJSQUEUENAMES).map(key => {
      return {
        type: 'bull',
        
        // Name of the bull queue, this name must match up exactly with what you've defined in bull.
        name: BULLJSQUEUENAMES[key],

        // Hostname or queue prefix, you can put whatever you want.
        hostId: BULLJSQUEUENAMESTOMODULEMAP[key],

        // Redis auth.
        redis: {
          ...jobConfigs.redis
        },

      }
    });

  }



}